module.exports = __webpack_public_path__ + "static/img/4.90d51b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/set/5/4.jpg
// module id = fPnc
// module chunks = 0